import React from "react";
import "./ConsultancyIntroForm.css";

export default function ConsultancyIntroForm({ data, onChange }) {
  return (
    <fieldset className="fra-ci-fieldset">
      <legend className="fra-ci-legend">Consultancy Introduction & Credentials</legend>
      
      {/* Intro Letter */}
      <div className="fra-ci-group">
        <textarea
          id="fra-ci-intro-letter"
          className="fra-ci-input"
          value={data.introLetter || ""}
          onChange={e => onChange({ ...data, introLetter: e.target.value })}
          placeholder=" "
          rows={5}
          required
        />
        <label htmlFor="fra-ci-intro-letter" className="fra-ci-label">
          Introductory Letter / Scope
        </label>
        <div className="fra-ci-helper">
          A formal intro for the client, purpose, and scope. You can edit this template text as needed.
        </div>
      </div>
      
      {/* Company Name */}
      <div className="fra-ci-group">
        <input
          id="fra-ci-company"
          className="fra-ci-input"
          value={data.company || ""}
          onChange={e => onChange({ ...data, company: e.target.value })}
          placeholder=" "
          required
        />
        <label htmlFor="fra-ci-company" className="fra-ci-label">
          Consultancy / Company Name <span className="fra-ci-required">*</span>
        </label>
      </div>

      {/* Consultant Name & Contact */}
      <div className="fra-ci-group">
        <input
          id="fra-ci-consultant-contact"
          className="fra-ci-input"
          value={data.consultantContact || ""}
          onChange={e => onChange({ ...data, consultantContact: e.target.value })}
          placeholder=" "
          required
        />
        <label htmlFor="fra-ci-consultant-contact" className="fra-ci-label">
          Consultant Name & Contact <span className="fra-ci-required">*</span>
        </label>
      </div>
      
      {/* Reviewer/Validator Name */}
      <div className="fra-ci-group">
        <input
          id="fra-ci-reviewer-contact"
          className="fra-ci-input"
          value={data.reviewerContact || ""}
          onChange={e => onChange({ ...data, reviewerContact: e.target.value })}
          placeholder=" "
        />
        <label htmlFor="fra-ci-reviewer-contact" className="fra-ci-label">
          Reviewer / Validator Name
        </label>
      </div>
    </fieldset>
  );
}
